import React from 'react';
import { ListItem, ListItemText } from '@material-ui/core';

export default ({ text, title }) => (
  <ListItem>
    <ListItemText primary={text} secondary={title}/>
  </ListItem>
);